import script from "./SkillpclanguageView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkillpclanguageView.vue?vue&type=script&lang=ts&setup=true"

import "./SkillpclanguageView.vue?vue&type=style&index=0&id=c442b02c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c442b02c"]])

export default __exports__